/* ---------- MCC-001's plug-in contacts: the units' incoming terminals' ends (#2037, #2934; #3006) ----------
 * Each unit's -XD280, -XD260 and -XD210 were incoming terminals, L1 L2 L3 PE PE2, standing for the plug-in contacts. They are the
 * plug-in contacts now (the library's plug_contacts): a clip on the busbar each (L1…, PE), the unit's conductors on the terminal named
 * after it (L1.1…; the PE's two, PE.1 and PE.2). A wire a learner saved on the old terminals lands on the clips, so it is not
 * traced and review counts it missing. The wires' ends move to the unit's terminals: L1 → L1.1, L2 → L2.1, L3 → L3.1; the bond to
 * the earthing busbar, old PE2, → PE.1; the line's PE, old PE, → PE.2, so a conductor the unit no longer has (the line's PE on to the
 * outgoing terminals, the bridge to PE2) stays the learner's and review shows it. Only wire ends ({ from, to }) move: a reading or a
 * fault names the clips, which keep their names. The save migration in packages/progress uses this (format 24); nothing else does.
 * Self-contained on purpose: the migration imports this file alone, not MCC-001's pack. */

/** The old terminal ends and the unit's terminals they move to, on each unit's plug-in contacts. */
export const MCC001_PLUG_ENDS: Record<string, string> = { L1: "L1.1", L2: "L2.1", L3: "L3.1", PE2: "PE.1", PE: "PE.2" };
const TAGS = ["XD280", "XD260", "XD210"];

const end = (v: unknown) => {
  if (typeof v !== "string") return v;
  const [tag, t, ...rest] = v.split(":");
  return !rest.length && TAGS.includes(tag) && t in MCC001_PLUG_ENDS ? `${tag}:${MCC001_PLUG_ENDS[t]}` : v;
};
const wire = (v: any): any =>
  Array.isArray(v) ? v.map(wire)
  : v && typeof v === "object" ? Object.fromEntries(Object.entries(v).map(([k, x]) => [k, (k === "from" || k === "to") ? end(x) : wire(x)]))
  : v;

/** A saved MCC-001 project ({ model, ui }) with its wires' ends on the plug-in contacts' terminals: -QA28's (ui.build), -QA26's and
 *  -QA21's (ui.builds), and each earlier attempt it keeps. */
export function plugMcc001Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = { ...s, ui: wire(s.ui ?? {}) };
  return Array.isArray(s.attempts) ? { ...out, attempts: s.attempts.map(a => ({ ...a, ui: wire(a?.ui ?? {}) })) } : out;
}
